/* AUTH */
export const GET_REPOSITES = 'GET_REPOSITES';
export const GET_REPOSITES_SUCCESS = 'GET_REPOSITES_SUCCESS';
export const GET_REPOSITES_FAILED = 'GET_REPOSITES_FAILED';
